import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { updateUserProfile } from 'services/profile.service';
import { useAuth } from 'context/AuthContext';
import { getAllNotifications } from 'services/notifications.service';

export default function Notifications() {
  const { user, userInfo, refreshUser } = useAuth();

  const [modalData, setModalData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [timeItem, setTimeItem] = useState<number>(0);

  async function closeNotification() {
    setLoading(true);
    const payload = [...modalData];

    await updateUserProfile({
      _id: user?._id,
      extra: {
        ...user?.extra,
        lastMessage: modalData[0].created,
      },
    });

    setTimeItem(modalData[0].created);

    payload.shift();
    setModalData(payload);

    refreshUser();
  }

  useEffect(() => {
    if (!userInfo || !user) return;
    if (modalData.length > 0) {
      setLoading(false);
      return;
    }

    loadNotifications(timeItem ? timeItem : user?.extra?.lastMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, user]);

  async function loadNotifications(time: number) {
    if (userInfo) {
      const data = await getAllNotifications(userInfo?.cad_missao, time);
      setModalData(data);
    }
  }

  if (!modalData || modalData?.length < 1 || loading) return null;

  const item = modalData[0];

  return (
    <div className="modal-notification absolute top-10 left-[10%] rounded-lg p-7 w-[90vw] lg:w-[471px]">
      <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeNotification()}>
        <IoIosClose size={26} />
      </button>

      {item?.text && <div className="relative w-full" dangerouslySetInnerHTML={{ __html: item?.text }}></div>}
    </div>
  );
}
